import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function() {

	const sliders = document.querySelectorAll('[data-name="continous-scroll"]');

	if (sliders.length > 0) {
		
		sliders.forEach(slider => {
			const theSlide = new Swiper(slider, {
				modules: [Autoplay],
				spaceBetween: 80,
				centeredSlides: true,
				speed: 2000,
				autoplay: {
					delay: 0,
				},
				loop: true,
				slidesPerView: 2,
				allowTouchMove: false,
				disableOnInteraction: false,
				breakpoints: {
					991: {
						slidesPerView: 'auto',
					},
					767: {
						slidesPerView: 2,
					},
				}
			});
		});
	}
}